/**
 * Phase 45 Plan 45-08 (D-13, Open Q7) — mark task read mutation.
 *
 * Fired by TaskDetailSlideOver on MOUNT (useEffect with [taskId] dep) — once
 * per slide-over open. POSTs /api/tasks/:taskId/read which UPSERTs the
 * caller's lastReadAt to NOW. On success the ['tasks', 'mine'] cache is
 * invalidated so the MyTasks row unread badge refreshes.
 *
 * Errors are intentionally silent (no toast): if marking a task as read
 * fails the worst case is a stale unread badge — not a user-blocking
 * condition.
 */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { markTaskRead } from '../services/api/taskReadState';
import { MY_TASKS_BASE_KEY } from './useMyTasks';

export function useMarkTaskRead() {
  const queryClient = useQueryClient();

  return useMutation<void, Error, number>({
    mutationFn: (taskId) => markTaskRead(taskId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: MY_TASKS_BASE_KEY });
    },
    // No onError toast — silently degrade per docstring.
  });
}
